<!--
 * @Author: jjchen
 * @Date: 2022-08-10 09:46:04
 * @LastEditors: jjchen
 * @LastEditTime: 2022-09-26 18:03:49
 * @Description: 高新技术企业测评首页
-->
<template>
  <div class="enterpriseHighNewH5">
    <div class="pageTop">
      <div class="lineIcon">
        <svg-icon icon-class="back" class="back" @click="goBack"></svg-icon>
        <div class="changeAccount" @click="addInfo">
          <svg-icon icon-class="change" class="change"></svg-icon>
          <span>补充信息测评更精确</span>
        </div>
      </div>
      <div class="title">
        <img src="@/assets/images/gx-title.png" alt="" />
      </div>
      <div class="desc">企业税收优惠、科技扶持政策门槛、企业品牌提升、上市重要条件</div>
      <van-field ref="companyNameRef" class="input" v-model="companyName" placeholder="请输入企业名称，如“公司宝”" @click-right-icon="getCorpInfo" @input="getCompanyList">
        <template #right-icon>
          <svg-icon icon-class="gx-search" class="gx-search"></svg-icon>
        </template>
      </van-field>
    </div>
    <dropDown ref="dropDownRef" :companyList="companyList" :visible.sync="visible" :flag="0" :loading="loading" :isEmpty="isEmpty" class="dropDown" @checkName="checkName" />
    <van-popup v-model="show" class="popup">
      <div class="prompt">
        <div class="promptHead">
          <div class="promptTitle">温馨提示</div>
          <svg-icon icon-class="gx-cancel" class="gx-cancel" @click="show = false"></svg-icon>
        </div>
        <div class="promptBody">
          <svg-icon icon-class="gx-null" class="gx-null"></svg-icon>
          <div>企业成立时间不足一年，不符合认定条件</div>
        </div>
        <div class="promptFooter" @click="show = false">我知道了</div>
      </div>
    </van-popup>
    <div class="list" v-for="(item, index) in list" :key="index" :class="item.path">
      <div class="listTitle">
        <div class="circleBox">
          <div class="circleThree circle"></div>
          <div class="circleTwo circle"></div>
          <div class="circleOne"></div>
        </div>
        <div class="titleText">{{ item.title }}</div>
        <div class="circleBox">
          <div class="circleOne circle"></div>
          <div class="circleTwo circle"></div>
          <div class="circleThree"></div>
        </div>
      </div>
      <div class="content" :class="index == 1 || index == 2 ? 'specialContent' : ''">
        <div v-for="(item, index) in item.content" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { highTechBasisReportApi, getCompanyInfoApi, getCorpInfoApi } from '@/api/enterpriseHighNewH5'
import dropDown from './components/dropDown.vue'
import moment from 'moment'
export default {
  components: {
    dropDown,
  },
  data() {
    return {
      show: false, //控制弹窗显示
      companyName: '', //企业名称
      reportContent: {}, //报告内容
      reportId: '', //报告Id
      companyList: [], //公司列表
      visible: false, //控制下拉框显示
      loading: true, //加载
      isEmpty: false, //暂无数据
      specialContent: '',
      list: [
        {
          title: '什么是高新技术企业',
          content: [
            '国家高新技术企业又称国家级高新技术企业，根据《高新技术企业认定管理办法》规定，国家高新技术企业是指在《国家重点支持的高新技术领域》内，持续进行研究开发与技术成果转化，形成企业核心自主知识产权，并以此为基础开展经营活动，在中国境内（不包括港、澳、台地区）注册一年以上的居民企业。',
          ],
          path: 'listOne',
        },
        {
          title: '高新技术企业认定的好处',
          content: [
            '一、税收减免：经认定的高新技术企业，可执行15%（认定前25%）的优惠税率，税率降低10个点，税额减少40%。',
            '二、直接奖励：获得高新后，可获得地方资金奖励（最多的有百万）。',
            '三、融资贷款：更容易获得VC的投资和各大银行的贷款。',
            '四、资助基础：是其他申报各类型政府专项资金的首要条件之一。',
            '五、品牌提升：科技类企业唯一“国”字招牌企业荣誉，电子商务时代极大利于促进企业异地成交，是企业实力的最佳象征。',
            '六、吸引人才：科技创业的核心是优秀人才，这样更能吸引他们。',
            '七、办公改善：优先获得办公及工业用地，很多地方还可以免费用地。',
            '八、政府采购：高新技术企业产品优先纳入政府采购体系。',
            '九、资产折旧：固定资产加速折旧，对财务报表有利。',
            '十、企业上市：创业板，新三板上市的重要条件之一。',
          ],
          path: 'listTwo',
        },
        {
          title: '高新技术企业认定的必要',
          content: [
            '一、促进企业科技转型：高新技术企业认定目的之一为了引导企业调整产业结构，走自主创新、持续创新的发展道路，激发企业自主创新的热情，提高科技创新能力。',
            '二、提升企业品牌形象：通过高新技术认定的企业是国家重点支持的具有高成长性的企业，具有较好的潜在经济效益。',
            '三、享受税收减免优惠政策：全国多地针对高新技术企业有专门的税收优惠政策。',
            '四、提升产品附加值：高新技术企业具有较强的技术创新能力、高端技术开发能力，作为很多招投标的重要条件。',
            '五、提高企业资本价值：高新技术企业是地方政府、行业组织对企业实施优惠政策和资金扶持的重要条件。',
            '六、资本市场加分：高新技术企业深受投资机构和金融机构青睐。',
          ],
          path: 'listThree',
        },
        {
          title: '高新技术企业测评的好处',
          content: [
            '高新技术企业测评解决如下难题：',
            '一、不清楚自己的公司是否符合国家高新技术企业认证的标准。',
            '二、不知道国家高新企业技术企业认证的申报关键点。',
            '三、新政策下国家高新企业认证申请有哪些注意点。',
          ],
          path: 'listFour',
        },
      ],
    }
  },
  created() {
    if (this.$route.query.userId) {
      let userInfo = {
        userId: this.$route.query.userId,
        username: this.$route.query.username,
        orgId: this.$route.query.orgId,
        orgName: this.$route.query.orgName,
      }
      if (this.$route.query.applets) {
        userInfo.applets = this.$route.query.applets
      }
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  },
  mounted() {
    const trigger = (el) => {
      if (this.visible) {
        if (this.$refs.dropDownRef.$el && !this.$refs.dropDownRef.$el.contains(el.target)) {
          this.visible = false
          this.companyName = ''
        }
      }
    }
    document.addEventListener('click', trigger)
  },
  methods: {
    // 点击补充信息跳转到测评页
    addInfo() {
      this.$router.push({
        name: 'enterpriseHighNewH5Evaluation',
        params: {
          companyName: this.companyName,
        },
      })
    },
    // 接收列表点击的值
    checkName(item) {
      this.companyName = item
    },
    goBack() {
      console.log(111)
      this.$router.go(-1)
    },
    getCompanyList() {
      if (this.companyName.trim()) {
        this.visible = true
        this.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.getCompanyInfo()
        }, 800)
      } else {
        this.visible = false
      }
    },
    // 高新测评报告-基础版
    async highTechBasisReport() {
      // if (!this.companyName) return
      const res = await highTechBasisReportApi({
        companyName: this.companyName,
      })
      if (res.code == 0) {
        this.reportId = res.data.reportId
        this.$router.push({
          path: '/enterpriseHighNewH5/basicReport',
          query: {
            reportId: res.data.reportId,
          },
        })
      }
    },
    // 获取公司列表
    async getCompanyInfo() {
      if (!this.companyName || !this.companyName.trim()) {
        this.visible = false
        return
      }
      this.loading = true
      const res = await getCompanyInfoApi({
        name: this.companyName,
      })
      if (res.code == 0) {
        this.companyList = res.data
        this.loading = false
        if (this.companyList.length > 0) {
          this.isEmpty = false
        } else {
          this.isEmpty = true
        }
      }
    },
    // 获取工商信息
    async getCorpInfo() {
      if (!this.companyName || !this.companyName.trim()) {
        // this.$notify('请输入企业名称')
        this.$notify({ type: 'warning', message: '请输入企业名称' })
        return
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
      const res = await getCorpInfoApi({
        companyName: this.companyName,
      })
      if (res.code == 0) {
        if (res.data.name == null) {
          this.$toast('暂未查询到相关信息，建议您重新输入')
          return
        }
        let m2 = res.data.foundedTime.replace('-', '/').replace('-', '/')
        if (moment().diff(moment(m2).format('YYYY-MM-DD'), 'year') < 1) {
          this.show = true
        } else {
          this.highTechBasisReport()
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
.enterpriseHighNewH5 {
  padding-bottom: 0.34rem;
  position: relative;
  .dropDown {
    width: 6.7rem;
    height: 4.48rem;
    position: absolute;
    top: 3.74rem;
    left: 0.4rem;
    z-index: 999;
  }
  .pageTop {
    width: 100%;
    height: 4.17rem;
    background-image: url('~@/assets/images/gxbg.png');
    background-size: 100% 100%;
    padding-top: 0.3rem;
    .lineIcon {
      display: flex;
      justify-content: space-between;
      margin: 0 0.3rem;
      .back {
        width: 0.2rem;
        height: 0.36rem;
      }
      .changeAccount {
        cursor: pointer;
        .change {
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.1rem;
        }
        span {
          font-size: 0.24rem;
          color: #ffffff;
        }
      }
    }
    .title {
      text-align: center;
      margin-top: 0.51rem;
      img {
        width: 6.84rem;
        height: 0.84rem;
      }
    }
    .desc {
      text-align: center;
      color: #b7d4fc;
      font-size: 0.22rem;
      margin-top: 0.11rem;
    }
    .van-cell {
      padding: 0.21rem 0.16rem 0.1rem;
    }
    .input {
      width: 6.7rem;
      height: 0.84rem;
      border-radius: 0.07rem;
      margin: 0.45rem auto 0px auto;
      .gx-search {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .popup {
    border-radius: 0.3rem;
    .prompt {
      width: 5.4rem;
      height: 5.7rem;
      margin-top: 0.22rem;
      .promptHead {
        height: 1.5rem;
        position: relative;
        .promptTitle {
          font-size: 0.36rem;
          font-weight: 500;
          position: absolute;
          top: 0.5rem;
          left: 1.98rem;
        }
        .gx-cancel {
          width: 0.36rem;
          height: 0.36rem;
          position: absolute;
          top: 0.3rem;
          right: 0.3rem;
          cursor: pointer;
        }
      }
      .promptBody {
        height: 3rem;
        display: flex;
        justify-content: center;
        font-size: 0.26rem;
        position: relative;
        .gx-null {
          width: 2.27rem;
          height: 2.4rem;
          position: absolute;
          top: 0;
          left: 1.57rem;
        }
        div {
          position: absolute;
          top: 2.06rem;
        }
      }
      .promptFooter {
        height: 1.2rem;
        background: #f7f7f7;
        border-radius: 0px 0px 0.3rem 0.3rem;
        font-size: 0.3rem;
        color: #999999;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }
  .listOne {
    background-image: url('~@/assets/images/gxbg1.png');
  }
  .listTwo {
    background-image: url('~@/assets/images/gxbg2.png');
  }
  .listThree {
    background-image: url('~@/assets/images/gxbg3.png');
  }
  .listFour {
    background-image: url('~@/assets/images/gxbg4.png');
  }
  .list {
    width: 7.1rem;
    min-height: 4.41rem;
    box-shadow: 0rem 0.04rem 0.14rem 0rem rgba(237, 243, 253, 0.47);
    border-radius: 0.09rem;
    border: 0.01rem solid rgba(0, 114, 247, 0.07);
    margin: 0.2rem auto 0 auto;
    position: relative;
    background-size: 2.05rem 1.32rem;
    background-repeat: no-repeat;
    background-position: right bottom;
    .listTitle {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.51rem;
      .titleText {
        font-size: 0.3rem;
        margin: 0 0.16rem;
      }
      .circleBox {
        height: 0.1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .circle {
          margin-right: 0.12rem;
        }
        .circleOne {
          width: 0.1rem;
          height: 0.1rem;
          border-radius: 50%;
          background: rgba(51, 113, 255, 0.7);
        }
        .circleTwo {
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 50%;
          background: rgba(51, 113, 255, 0.5);
        }
        .circleThree {
          width: 0.04rem;
          height: 0.04rem;
          background: rgba(51, 113, 255, 0.3);
        }
      }
    }
    .content {
      width: 6.5rem;
      // height: 2.73rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #777777;
      margin: 0.37rem auto 0 auto;
    }
    .specialContent {
      padding-bottom: 0.5rem;
    }
  }
}
</style>
